import React, { useState, useMemo, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import addbtn from 'assets/img/add-icon2.svg';
import { useSocket } from 'pages/projects/kanban/context/SocketContext';

const OPEN_ID = '6942d67c625a9e01f360ae63';
const CLOSE_ID = '6942d67c625a9e01f360ae66';

const AddStatusModal = ({ show, onHide, channelStatusOptions, channelslist, projectBoardId }) => {
  const socket = useSocket();
  const [updatedChannels, setUpdatedChannels] = useState([]);
  // Store selected status per channelId

  // Check if Open or Close is already selected

  const openChannelId = useMemo(() => updatedChannels.find((ch) => ch.status === OPEN_ID)?._id, [updatedChannels]);

  const closeChannelId = useMemo(() => updatedChannels.find((ch) => ch.status === CLOSE_ID)?._id, [updatedChannels]);
  const usedStatusMap = useMemo(() => {
    const map = {};
    updatedChannels.forEach((ch) => {
      if (ch.status === OPEN_ID) map[OPEN_ID] = ch._id;
      if (ch.status === CLOSE_ID) map[CLOSE_ID] = ch._id;
    });
    return map;
  }, [updatedChannels]);

  useEffect(() => {
    if (show && channelslist?.length) {
      setUpdatedChannels(
        channelslist.map((ch) => ({
          ...ch,
          status: ch.status?._id || ch.status || null
        }))
      );
    }
  }, [show, channelslist]);

  const getOptionsForChannel = (channelId) =>
    channelStatusOptions.map((option) => {
      const usedBy = usedStatusMap[option.value];

      return {
        ...option,
        isDisabled: Boolean(usedBy && usedBy !== channelId)
      };
    });

  const handleChange = (channelId, selectedOption) => {
    setUpdatedChannels((prev) =>
      prev.map((ch) => (ch._id === channelId ? { ...ch, status: selectedOption.value } : ch))
    );
  };

  const handleSubmit = () => {
    const channelsPayload = updatedChannels.map((channel) => ({
      id: channel._id,
      name: channel.name,
      isCollapsed: channel.isCollapsed,
      sequence: channel.sequence,
      status: channel.status?._id ? channel.status?._id : channel.status
    }));

    socket.emit('bulk-update-channels', {
      projectBoardId,
      channels: channelsPayload
    });

    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} centered className="modal-status">
      <Modal.Header closeButton>
        <div className="modal-title">Edit List Statuses</div>
      </Modal.Header>

      <Modal.Body className='modal-body-content'>
        <div className="status-body">
          {updatedChannels?.map((channel) => (
            <div className="status-card" key={channel._id}>
              <label>{channel.name}</label>

              <Select
                options={getOptionsForChannel(channel._id)}
                value={channelStatusOptions.find((opt) => opt.value === channel.status)}
                onChange={(option) => handleChange(channel._id, option)}
                placeholder="Select status"
                classNamePrefix="react-select"
              />
            </div>
          ))}

          {/* <div className="status-card">
            <a href="#" className="add-status">
              <img src={addbtn} className="addbtn" alt="add" />
              Add Status
            </a>
          </div> */}

          <div className="save-templete-group-btn" onClick={handleSubmit}>
            <button className="black-btn cursor_pointer">Apply changes</button>
          </div>
        </div>
        <div className='status-meaning'>
            <h3>Status Meaning</h3>
            <div className='statusMeaning-card'>
              <h4>Pending</h4>
             <p>Work that’s approved and ready to begin, but not actively in progress yet.<b>Think: queued, planned, or waiting on a start date.</b> </p>
            </div> 
            <div className='statusMeaning-card'>
              <h4>Active</h4>
             <p>Work that is currently being worked on. <b>This is where momentum lives—tasks should be moving regularly.</b> </p>
            </div> 
            <div className='statusMeaning-card'>
              <h4>Done</h4>
             <p>Work that’s completed but not finalized. <b>Use this for internal review, client sign-off, or final checks.</b> </p>
            </div> 
            <div className='statusMeaning-card'>
              <h4>Closed</h4>
             <p>Work that’s fully complete and approved. <b> Nothing more to do—this is the finish line.</b> </p>
            </div> 
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default AddStatusModal;
